module.exports = __webpack_public_path__ + "e5d07bc319df6f1987fe8ec174ac8045.png";